import React, { Component, Fragment } from 'react';
import intl from 'react-intl-universal';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';


class EditUser extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userID: this.props.edituserdata.id,
      accountId: this.props.edituserdata.accountId,
      firstName: this.props.edituserdata.firstName,
      lastName: this.props.edituserdata.lastName,
      description: this.props.edituserdata.description,
      tendant: this.props.tendants,
      password: "",
      password1: "",
      passworderror: false
    }
}

handleChange(e) {
  this.setState({
    [e.target.name]: e.target.value
  })
}

handleChangeTendant = (event) =>{   
  this.setState ({
    accountId: +event.target.value    
  })
}

submitupdateuser = (event) =>{  
  event.preventDefault()

  let json = "";

  if (this.state.password !== this.state.password1) {
    this.setState ({
        passworderror: true
    })
  } else {
 
  let jsonfields= "";
  jsonfields += '"id": "' + this.state.userID + '",';
  jsonfields += '"accountId": "' + this.state.accountId + '",';
  jsonfields += '"firstName": "' + event.currentTarget.firstName.value + '",';
  jsonfields += '"lastName": "' + event.currentTarget.lastName.value + '",';
  if (this.props.isadmin) {
  jsonfields += '"password": "' + event.currentTarget.password.value + '",';
  }
  jsonfields += '"isActive": "true",';
  jsonfields += '"description": "' + event.currentTarget.description.value + '"';

  
  json = '{';
  json += jsonfields;
  json += '}';

}

  //console.log(json)
  this.updateuser(this.props.token, this.state.userID,json)

}

updateuser (token,userID,json)  {
  let apiurl = window.apiurl
  console.log(json)
  fetch("https://"+apiurl+"/api/User/"+userID, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: json
    })
      .then(res => res.json())
      .then(json => {
        console.log("---------------")
        console.log(json)
        console.log("---------------")
        this.props.closedit(this.props.page)
      })
      .catch(function(error) {
          console.log(error.status);
        });         
    }

    render () {  
        
       //console.log (this.props)
       //console.log (this.state.accountId)
       let tendantlist
       let existuser
       
     if(this.state.accountId !== ""){
       tendantlist =  this.state.tendant.filter(function(tendantuser, i)  {
       // console.log(typeof(tendantuser.id) + "|" + typeof(this.state.accountId))
        if (tendantuser.id !== this.state.accountId){
          return tendantuser
        }
      }, this)



      existuser =  this.state.tendant.filter(function(tendantuser, i)  {
       // console.log(tendantuser)
        if (tendantuser.id === this.state.accountId){
          return tendantuser
        }
      }, this)

    }
        
     

      return (
          <Fragment>
          <Container maxWidth="sm">
          <CloseIcon onClick={()=>this.props.closedit(this.props.page)} />

          <Typography variant="h6" gutterBottom>
          {intl.get('ADMIN_EDITUSER_FORM')} :
          </Typography>

 {this.state.passworderror &&
        <Alert severity="error">{intl.get('ACCOUNT_EDIT_PW_ALERT')}</Alert>
  }

   

<Box component="form" onSubmit={this.submitupdateuser}  Validate >
 <Grid container spacing={3}>
   <Grid item xs={12}>
     <TextField
       required
       id="firstName"
       name="firstName"
       label={intl.get('ACCOUNT_EDIT_FORM_VORNAME')}
       value={this.state.firstName}   
       onChange={(e) => this.handleChange(e)}
       fullWidth
       variant="standard"
     />
   </Grid>
   <Grid item xs={12}>
     <TextField
       required
       id="lastName"
       name="lastName"
       label={intl.get('ACCOUNT_EDIT_FORM_NACHNAME')}
       value={this.state.lastName} 
       onChange={(e) => this.handleChange(e)}
       fullWidth
       variant="standard"
     />
   </Grid>
   
   <Grid item xs={12}>
     <TextField
       required
       id="description"
       name="description"
       label={intl.get('ACCOUNT_EDIT_FORM_BESCHREIBUNG')}
       value={this.state.description}
       onChange={(e) => this.handleChange(e)}
       multiline
       rows={4}
       fullWidth
       variant="standard"
     />
   </Grid>

   {this.props.isadmin &&
   <Fragment>
     
  

   <Grid item xs={12}>
  
     <Typography variant="h6" gutterBottom>
          {intl.get('ADMIN_NEWUSER_FORM_EDITZU')} :
          </Typography>
          <strong>{existuser[0].name}</strong>
          <hr />

          <TextField
            
            id="password"
            name="password"
            label={intl.get('ACCOUNT_EDIT_FORM_PW')}
            fullWidth
            onChange={(e) => this.handleChange(e)}
            type="password"
            variant="standard"
          />
        </Grid>
  <Grid item xs={12}>
      <TextField
      
      id="password1"
      name="password1"
      label={intl.get('ACCOUNT_EDIT_FORM_PW1')}
      fullWidth
      onChange={(e) => this.handleChange(e)}
      type="password"
      variant="standard"
   />
 </Grid>
 <Grid  item xs={12}>
                  <select className="userselect full" onChange={this.handleChangeTendant}>
                      <option key="0" value="">{intl.get('ADMIN_LISTSELECT_TENANT')}</option>
                          {tendantlist.map(tendant => {
                            return (<option key={tendant.id} value={tendant.id}>{tendant.name}</option>);
                          })
                          }
                        </select>
                    </Grid>
 </Fragment>

  }
   
       <Grid item xs={12}>
       <Button
       type="submit"
       fullWidth
       variant="contained"
       sx={{ mt: 3, mb: 2 }}
     >
      {intl.get('ADMIN_EDITUSER_FORM_SUBMIT')} :
     </Button>
     </Grid>

 </Grid>
 </Box>
 
 </Container>
 </Fragment> 
        )
    }
}


export default EditUser;